import axios from '@api/axiosInstance.js'

export const fetchSearchCoins = async (key) => {
  const res = await axios.post(`/coin/all`, { key })
  return res.data
}